'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultHashFunction() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return args[0];
  }
  return (0, _immutable.Seq)(args);
}

function memoized1(cache, operation, hashFunction) {
  for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  var key = hashFunction.apply(undefined, args);
  if (!cache.has(key)) {
    cache.set(key, operation.apply(undefined, args));
  }
  return cache.get(key);
}

function memoizedN(cache, operation, hashFunction) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var key = hashFunction.apply(undefined, args);
  if (!cache.has(key)) {
    cache.set(key, operation.apply(undefined, args));
  }
  return cache.get(key);
}

/**
 * Memoizer that uses a `Map` to allow for arbitrarily many/complex keys.
 *
 * @example
 * const sum = memoize((list) => {
 *   return list.reduce((total, n) => total + n, 0);
 * });
 * // does work and returns 15
 * sum(List.of(1, 2, 3, 4, 5))
 * // returns 15 but does no work
 * sum(List.of(1, 2, 3, 4, 5))
 *
 * @example <caption>We can use the `hashFunction` param to customize the key used in the cache.</caption>
 * const sum = memoize(
 *   (list) => list.reduce((total, n) => total + n, 0),
 *   (list) => return list.join('-')
 * );
 *
 * @example <caption>It's also possible to inspect the state of an instance by reading the `.cache` property.</caption>
 *
 * const sum = memoize(...);
 * Map.isMap(sum.cache) === true;
 *
 * @param  {Function}  operation to memoize.
 * @param  {Function}  hashFunction that generates the cache key.
 * @return {Function}  memoized version of `operation`.
 */
function memoize(operation) {
  var hashFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultHashFunction;

  (0, _enforceFunction3.default)(operation);
  var cache = (0, _immutable.Map)().asMutable();
  var memoizer = operation.length === 1 ? memoized1 : memoizedN;
  var result = memoizer.bind(null, cache, operation, hashFunction);
  result.cache = cache;
  return result;
}
module.exports = exports['default'];